/**
 * Created by Rumyantsev Daniil on 07.08.2018.
 */
import { NgModule }  from '@angular/core';

import {PipesModule} from '../pipe/pipes-module';
import {FlashMessagesModule} from 'angular2-flash-messages';
import {ModalWindowComponent} from './modal-window/modal-window.component';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FileLoadComponent} from './file/file-load/file-load.component';
import {FileService} from './file/file.service';
import {FileComponent} from './file/file.component';
import {NotFoundComponent} from "./not-found/not-found.component";
import {FlashMessagesComponent} from "angular2-flash-messages/module/flash-messages.component";

@NgModule({
  imports: [
    PipesModule,
    FlashMessagesModule,
    FormsModule,
    CommonModule,
  ],
  exports : [
    FormsModule,
    CommonModule,
    ModalWindowComponent,
    PipesModule,
    FlashMessagesModule,
    FileLoadComponent,
    FileComponent,
    NotFoundComponent,
    FlashMessagesComponent
  ],
  declarations: [
    ModalWindowComponent,
    FileLoadComponent,
    FileComponent,
    NotFoundComponent
  ],
  providers: [
    FileService,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/shared.module.ts